import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import PaletteOutlined from "@mui/icons-material/PaletteOutlined";
import type { NodeKey } from "lexical";
import { type FC, useCallback, useState } from "react";
import type { PopoverController } from "../../../../../../utils/hooks/use-popover";
import { ColourPicker } from "../../../../../generic/components/colour-picker/colour-picker";
import { SET_TABLE_CELL_BACKGROUND_COLOUR_COMMAND } from "../../../types/commands";
import { ToolbarIconButton } from "../../toolbar/toolbar-icon-button";

export const BackgroundColourButton: FC<{
  initialColour: string;
  nodeKey: NodeKey;
  popoverInputRef: React.RefObject<HTMLInputElement | null>;
  popover: PopoverController<HTMLButtonElement>;
}> = ({ initialColour, nodeKey, popoverInputRef, popover }) => {
  const [editor] = useLexicalComposerContext();
  const [colour, setTempColour] = useState<string>(initialColour);

  const setColour = useCallback(
    (c: string, skipHistory?: boolean) => {
      editor.dispatchCommand(SET_TABLE_CELL_BACKGROUND_COLOUR_COMMAND, {
        nodeKey,
        colour: c,
        skipHistory,
      });
      setTempColour(c);
    },
    [editor, nodeKey],
  );

  return (
    <>
      <ToolbarIconButton
        data-analytics-id="lexical-table-menu-cell-background-colour"
        disabled={!editor._editable}
        label={"Background color"}
        icon={<PaletteOutlined fontSize="small" />}
        data-testid="table-menu-colour"
        aria-label="change-cell-background-colour"
        onClick={popover.handleToggle}
      />
      <ColourPicker
        popover={popover}
        colour={colour}
        onChange={setColour}
        inputRef={popoverInputRef}
      />
    </>
  );
};
